export default "__VITE_ASSET__CPnLGGrZ__"